export const TRANSACTION_PATHS = {
  TRANSACTIONS: "/transactions",
};
